import React from 'react';
import Helmet from 'react-helmet';
const Metadata = _ref => {
  let {
    canonical,
    description,
    keywords,
    title,
    noIndex = false,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, title), keywords && /*#__PURE__*/React.createElement("meta", {
    name: "keywords",
    content: keywords
  }), description && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }), noIndex && /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: "noindex"
  }), canonical && /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: canonical
  }), children);
};
export default Metadata;